import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableBody,
  CircularProgress,
  IconButton,
} from "@mui/material";
import configServ from "../../services/config";
import { Delete } from "@mui/icons-material";
import toast from "react-hot-toast";

const AssignHolidayDialog = ({ open, onClose, holiday, batchList }) => {
  const [batchId, setBatchId] = useState([]);

  useEffect(() => {
    if (!open) {
      setBatchId([]);
    }
  }, [open]);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        holiday_id: holiday,
        batch_ids: batchId,
      };

      const result = await configServ.assignHolidayToBatches(payload);

      if (result.status) {
        toast.success("Holiday assigned successfully");
        onClose();
      } else {
        toast.error(result.message || "Failed to assign holiday");
      }
    } catch (error) {
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const [holidayBatches, setHolidayBatches] = useState([]);
  const [loadingBatches, setLoadingBatches] = useState(false);

  const fetchHolidayOFBatches = async () => {
    setLoadingBatches(true);
    try {
      const result = await configServ.getAllBatchesHoliday(holiday);
      if (result.status) {
        setHolidayBatches(result.data);
      }
    } catch (error) {
      console.log("Error fetching holiday batches", error);
      setHolidayBatches([]);
    } finally {
      setLoadingBatches(false);
    }
  };
  useEffect(() => {
    if (open) {
      fetchHolidayOFBatches();
    }
  }, [open]);

  const handleRemoveBatch = async (holidayBatchId) => {
    setLoadingBatches(true);

    try {
      const res = await configServ.deleteHolidayBatch(holidayBatchId);
      if (res.status) {
        toast.success("Batch removed from holiday successfully");
        fetchHolidayOFBatches(); // refresh list
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingBatches(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Assign Holiday to Batch</DialogTitle>

      <DialogContent>
        <TextField
          select
          fullWidth
          label="Select Batch"
          value={batchId}
          onChange={(e) => setBatchId(e.target.value)}
          margin="normal"
          SelectProps={{
            multiple: true,
          }}
        >
          {batchList.map((batch) => (
            <MenuItem key={batch.id} value={batch.id}>
              {batch.item_name}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!batchId || loading}
        >
          Assign
        </Button>
      </DialogActions>
      <Table size="small" sx={{ mt: 2 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#000" }}>
            <TableCell sx={{ color: "#fff" }}>#</TableCell>
            <TableCell sx={{ color: "#fff" }}>Batch Name</TableCell>
            <TableCell sx={{ color: "#fff" }}>Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {/* 🔄 Loading State */}
          {loadingBatches && (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <CircularProgress size={24} />
              </TableCell>
            </TableRow>
          )}

          {/* 📦 Data */}
          {!loadingBatches &&
            holidayBatches.map((row, index) => (
              <TableRow key={row.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.batch_name}</TableCell>
                <TableCell>
                  <IconButton
                    color="error"
                    onClick={() => handleRemoveBatch(row.id)}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

          {/* 🚫 Empty State */}
          {!loadingBatches && !holidayBatches.length && (
            <TableRow>
              <TableCell colSpan={3} align="center">
                No batch assigned
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Dialog>
  );
};

export default AssignHolidayDialog;
